import { render, staticRenderFns } from "./ChangeCollaboratorStatus.vue?vue&type=template&id=0dc63516&"
import script from "./ChangeCollaboratorStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeCollaboratorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports